import {
	Box,
	Button,
	Grid,
	Modal as MuiModal,
	Paper,
	Typography,
} from '@mui/material'

const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: 400,
	boxShadow: 24,
	p: 4,
	textAlign: 'center',
}

function Modal({ modal, setModal }) {
	const handleClose = () => {
		setModal(false)
	}

	return (
		<MuiModal
			open={!!modal}
			onClose={handleClose}
			aria-labelledby="modal-title"
			aria-describedby="modal-description"
		>
			<Paper sx={style}>
				<Typography variant="h2">{modal?.title}</Typography>
				{modal?.body && <Box my={2}>{modal.body}</Box>}
				{modal?.buttons && (
					<Grid container mt={2} justifyContent="center">
						{modal?.buttons?.map(({ label, onClick }) => (
							<Grid item mx={1} key={label}>
								<Button
									variant="contained"
									onClick={() => {
										onClick && onClick()
										handleClose()
									}}
								>
									{label}
								</Button>
							</Grid>
						))}
					</Grid>
				)}
			</Paper>
		</MuiModal>
	)
}

export default Modal

